/**
 * @desc 获取物流分组列表
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.LogisticsGroupResponseDto>>;
export function request(options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsGroup/getList`, {
      method: "GET",

      ...options,
    }),
  );
}
